import { z } from "zod";

export const cxMappingSchema = z.object({
  id: z.string(),
  externalId: z.string(),
  cxId: z.string(),
  source: z.string(),
  secondaryMappings: z.record(z.string(), z.any()).nullish(),
  defaultCohortId: z.string().nullable().optional(),
});

export type CxMapping = z.infer<typeof cxMappingSchema>;

export const patientMappingSchema = z.object({
  id: z.string(),
  cxId: z.string(),
  patientId: z.string(),
  externalId: z.string(),
  source: z.string(),
  secondaryMappings: z.record(z.string(), z.any()).nullish(),
  createdAt: z.string(),
  updatedAt: z.string(),
  version: z.number(),
});

export type PatientMapping = z.infer<typeof patientMappingSchema>;
